import React, { useEffect } from 'react';
import { Provider } from 'react-redux';
import { store } from 'store/store';
import { systemEndpoints } from 'constants/endpoints';
import Request from 'common/network/Request';
import Routes from 'routes';

import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { ConfigProvider, Spin } from 'antd';
import SaleImportingMaintenance from 'components/layout/SaleImportingMaintenance';
import Container from 'components/layout/Container';
import { BrowserRouter } from 'react-router-dom';
import viVN from 'antd/es/locale/vi_VN';
import 'dayjs/locale/vi';
import relativeTime from 'dayjs/plugin/relativeTime';
import isBetween from 'dayjs/plugin/isBetween';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(relativeTime);
dayjs.extend(isBetween);
dayjs.locale('vi');

window.logState = () => {
  const state = store.getState();
  console.info({ state });
};

const App = () => {
  const [isImportSaleResult, setIsImportSaleResult] = React.useState({});
  const [loading, setLoading] = React.useState(true);

  const getImportSaleResult = React.useCallback(async () => {
    setLoading(true);
    try {
      const response = await Request.get(systemEndpoints.checkImportingSale);
      setIsImportSaleResult(response?.result);
    } catch (error) {
      console.error(error);
    }
    setLoading(false);
  }, []);

  useEffect(() => {
    getImportSaleResult();
  }, [getImportSaleResult]);

  return (
    <Provider store={store}>
      <ConfigProvider
        theme={{
          token: {
            colorPrimary: '#0079c1',
            fontFamily: `"Noto Sans", 'ui-sans-serif', 'system-ui'`,
          },
        }}
        locale={viVN}
      >
        <Spin spinning={loading}>
          {isImportSaleResult?.is_importing ? (
            <SaleImportingMaintenance result={isImportSaleResult} />
          ) : (
            <BrowserRouter>
              <Container>
                <Routes />
              </Container>
            </BrowserRouter>
          )}
        </Spin>
      </ConfigProvider>
    </Provider>
  );
};

export default App;
